import React from 'react';
import { useParams } from 'react-router-dom';
import NuovoRefertoCardiologia from '../pages/specialties/cardiologia/NuovoReferto';
import NuovoRefertoDermatologia from '../pages/specialties/dermatologia/NuovoReferto';
import NuovoRefertoMedicinaInterna from '../pages/specialties/medicina-interna/NuovoReferto';
import { toast } from 'react-toastify';

const DynamicNuovoReferto: React.FC = () => {
  const { specialtyName } = useParams<{ specialtyName: string }>();

  // Mappa i nomi delle specialistiche ai componenti
  const specialtyComponents = {
    'cardiologia': NuovoRefertoCardiologia,
    'dermatologia': NuovoRefertoDermatologia,
    'medicina-interna': NuovoRefertoMedicinaInterna,
  };

  // Ottieni il componente corretto basato sulla specialistica
  const SpecialtyComponent = specialtyName ? specialtyComponents[specialtyName as keyof typeof specialtyComponents] : null;

  if (!SpecialtyComponent) {
    toast.error(`Specialistica "${specialtyName}" non trovata`);
    return (
      <div className="text-center p-4">
        <h3>Specialistica non trovata</h3>
        <p>La specialistica "{specialtyName}" non è supportata.</p>
      </div>
    );
  }

  return <SpecialtyComponent />;
};

export default DynamicNuovoReferto;
